import type { IntlShape } from 'react-intl';
import type { SubscriptionFeature } from '@alltrails/types/SubscriptionFeature';
import wrongTurnAlertsSrc from './images/wrong-turn-alerts-thumb.avif';

const wrongTurnAlerts = (intl: IntlShape): SubscriptionFeature => ({
  headline: intl.formatMessage({ defaultMessage: 'Wrong-Turn Alerts' }),
  subheadline: intl.formatMessage({ defaultMessage: 'Focus on the beauty around you, not the map, with wrong-turn alerts' }),
  thumbnailImage: wrongTurnAlertsSrc.src
});

export default wrongTurnAlerts;
